import { DataTableV2, defaultColDef } from "@platform/design-system";
import { useParams } from "react-router";
import { useMemo } from "react";
import { GetDataPath } from "ag-grid-community";
import capitalize from "lodash/capitalize";
import { Box } from "@mui/material";

import { InOutTreeRow } from "../types";
import { useLocCombinedQuery } from "../../../hooks/useBbe";
import {
  CARRIER_NAME_MAP,
  CarrierName,
  IN_OUT_TABLE_COLUMN_HEADERS,
  IN_OUT_TABLE_GROUP_COLUMN_HEADER,
} from "../constants";
import { buildTreeRows } from "../utils";

const getDataPath: GetDataPath<InOutTreeRow> = (row) => row.dataPath;

export const InOutTable: React.FC<{ carrierName?: string }> = ({
  carrierName,
}) => {
  const { id: brokerIdParam } = useParams<{
    id: string;
    carrierId: string;
  }>();

  const carrierNameMapped = carrierName
    ? capitalize(CARRIER_NAME_MAP[carrierName as CarrierName])
    : undefined;

  const { data: locData, isLoading } = useLocCombinedQuery(
    brokerIdParam ?? "",
    carrierNameMapped,
  );

  const rowData = useMemo(
    () => (locData ? buildTreeRows(locData) : []),
    [locData],
  );

  const columns = IN_OUT_TABLE_COLUMN_HEADERS.map((col) => ({
    ...defaultColDef,
    ...col,
    cellStyle: {},
  }));
  const autoGroupColumnDef = {
    ...defaultColDef,
    ...IN_OUT_TABLE_GROUP_COLUMN_HEADER,
    cellStyle: {},
  };

  return (
    <Box
      sx={{
        "& .ag-root-wrapper": {
          maxHeight: "40vh",
        },
        "& .ag-root-wrapper-body": {
          minHeight: "0 !important",
        },
        "& .ag-body": {
          minHeight: "0 !important",
        },
        "& .ag-body-viewport": {
          overflowY: "auto !important",
        },
      }}
    >
      <DataTableV2
        treeData
        rowData={rowData}
        autoGroupColumnDef={autoGroupColumnDef}
        columnDefs={columns}
        getDataPath={getDataPath}
        loading={isLoading}
        groupDefaultExpanded={0}
        gridOptions={{
          pagination: false,
          suppressPaginationPanel: true,
          alwaysShowVerticalScroll: true,
        }}
      />
    </Box>
  );
};
